const T = {
  // Colors
  color: {
    primary: '#2563eb',
    primaryHover: '#1d4ed8',
    text: '#111',
    textMuted: '#555',
    textLight: '#666',
    border: '#e2e5e9',
    borderLight: '#eee',
    bg: '#fff',
    cardBg: '#fff',
    success: '#3f6212',
    warning: '#b45309',
    danger: '#b00020',
    dangerMuted: '#9a3412',
    strava: '#fc4c02',
    link: '#06c',
    // Section accents (thin left border)
    accentPace: '#2563eb',
    accentWorkout: '#7c3aed',
    accentNutrition: '#ea580c',
    accentRecovery: '#16a34a',
    accentBands: '#0891b2',
    accentRun: '#0f766e',
    accentSchedule: '#9333ea',
    accentFeedback: '#64748b',
    textSecondary: '#333',
    meterDefault: '#64748b',
    warningElevated: '#ca8a04',
    meterNormal: '#4d7c0f',
  },

  chart: {
    temperature: '#ff6384',
    dewPoint: '#36a2eb',
    pace: '#4bc0c0',
    dni: '#f5c518',
  },

  // Spacing (4px base)
  space: [0, 4, 8, 12, 16, 24, 32],

  // Typography
  font: {
    xs: 12,
    sm: 13,
    base: 14,
    lg: 18,
    xl: 24,
    xxl: 28,
  },

  // Shadows
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.08)',
    cardHover: '0 2px 8px rgba(0,0,0,0.12)',
    modal: '0 8px 24px rgba(0,0,0,0.2)',
  },

  // Border radii
  radius: {
    sm: 6,
    base: 8,
    lg: 12,
    pill: 9999,
  },

  // Reusable style objects
  cardStyle: {
    borderRadius: 8,
    padding: 16,
    margin: '16px 8px',
    maxWidth: 560,
    borderLeft: '3px solid transparent',
  },

  modalOverlayStyle: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 20,
  },

  modalBoxStyle: {
    background: '#fff',
    borderRadius: 8,
    padding: 20,
    minWidth: 280,
    maxWidth: 420,
    maxHeight: '90vh',
    overflowY: 'auto',
    boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
  },

  inputStyle: {
    display: 'block',
    marginTop: 6,
    width: '100%',
    boxSizing: 'border-box',
  },

  labelStyle: {
    display: 'block',
    margin: '12px 0',
  },

  linkButtonStyle: {
    background: 'none',
    border: 'none',
    padding: 0,
    color: '#06c',
    textDecoration: 'underline',
    cursor: 'pointer',
    font: 'inherit',
  },

  // Table cell padding
  cellStyle: {
    padding: '6px 8px',
    fontVariantNumeric: 'tabular-nums',
  },

  cellHeaderStyle: {
    textAlign: 'left',
    padding: '6px 8px',
    borderBottom: '1px solid #e2e5e9',
    fontSize: 13,
    fontWeight: 600,
    color: '#555',
  },
};

export default T;
